import React, { useMemo } from 'react';
import { useSelector } from '../hook-utils';
import { Squad } from '../model';
import { selectSquads, selectSquad } from '../store/reducers/squads';
import { TableColumn } from './FlexTable';
import { QueuesPageTable } from './QueuesPage';
import { selectSingleQueueOrSquad } from '../store/reducers/config';

const columns: TableColumn<Squad>[] = [{
  id: 'name',
  accessor: t => t.description,
  Header: 'Squad name',
}]

export default function SquadsTable() {
  const single = useSelector(selectSingleQueueOrSquad)
  const squad = useSelector(s => single ? selectSquad(s, single) : null)
  const squads = useSelector(selectSquads)

  const data = useMemo(() => (squad ? [squad] : squads) || [], [squad, squads])

  return <QueuesPageTable data={data} loading={!squads} columns={columns} />
}
